<template>
  <div>
    <headerNotice routerName="申请详情"></headerNotice>
    <!-- 基本信息 -->
    <div class="baseInfo" v-loading="loading">
      <div class="table">
        <el-form :model="formData" class="signUp_Form" label-width="200px">
          <el-row>
            <el-col :span="10">
              <el-form-item label="药店名称：">
                <el-input
                  v-model="formData.name"
                  size="small"
                  maxlength="50"
                  placeholder=""
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="地址：">
              <span>{{formData.provinceName+formData.cityName+formData.areaName}}</span>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="10">
              <el-form-item label="电话号码：">
                <el-input
                  class="inputStyle"
                  v-model="formData.phone"
                  size="small"
                  placeholder=""
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <h1>购物小票</h1>
          <div class="goodsBox">
            <el-row>
              <el-col>
                <el-upload
                  :accept="accept"
                  :headers="headers"
                  class="upload-demo"
                  :action="uploadAction"
                  list-type="picture-card"
                  :file-list="goodsImagesList"
                  :before-upload="beforeUpload"
                  :disabled=true
                >
                 <div  v-if="goodsImagesList && goodsImagesList.length > 0" class="divImg" slot="file" slot-scope="{file}">
                <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.url" alt=""
                >
                <span class="el-upload-list__item-actions">
                    <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                    >
                    <i class="el-icon-zoom-in"></i>
                    </span>
                </span>
                </div>
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                 <!-- <v-upload :imgList="goodsImagesList" :limit="limit" @getImgList="getImgList" class="upd"></v-upload> -->
              </el-col>
            </el-row>
          </div>
          <el-row>
            <el-col :span="10">
              <el-form-item label="店铺名称：" :rules="{ required: true }">
                <el-input
                  v-model="formData.storeName"
                  size="small"
                  maxlength="50"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="小票单号：" :rules="{ required: true }">
                <el-input
                  class="inputStyle"
                  v-model="formData.receiptNo"
                  size="small"
                  placeholder=""
                  @blur="blurinput()"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="销售数量：" :rules="{ required: true }">
                <el-input
                  v-model="formData.salesVolumes"
                  size="small"
                  maxlength="50"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="小票金额：" :rules="{ required: true }">
                <el-input
                  class="inputStyle"
                  v-model="formData.ticketAmount"
                  size="small"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="支付微信：">
                <img  width="500px" :src="baseUrl + formData.collectionCode" alt />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="状态：" :rules="{ required: true }">
                <el-select v-model="formData.status" placeholder="请选择状态：">
                  <el-option
                    v-for="item in unitList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="10">
              <el-form-item label="备注：" :rules="{ required: true }">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  placeholder="请输入内容"
                  v-model="formData.remarks"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
           <el-row>
            <el-col :span="10">
              <el-form-item label="审核备注：" :rules="{ required: true }">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  placeholder="请输入内容"
                  v-model="formData.examineRemarks"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
 <el-dialog 
            append-to-body 
            :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      <!-- 保存 " -->
      <div class="saveBox">
        <el-button @click="back">返回</el-button>
        <el-button
          type="primary"
        
          :loading="btnLoading"
          class="add"
          @click="confirmEdit()"
            v-if="formData.flat==1"
          >确认修改</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
import Vupload from "./../../components/common/upload.vue";

export default {
  name: "applydetail",
  components: {
    "v-upload": Vupload
  },
  data() {
    return {
      loading: true,
      itemID: null,
      items: {},
      formData: {
        flat: 0,
      },
      unitList: [
        {
          value: 1,
          label: "待审核",
        },
        {
          value: 2,
          label: "已审核",
        },
        {
          value: 3,
          label: "已拒绝",
        },
      ], //所有单位数据
       limit: 5,
      brandList: [], //所有品牌数据
      showCateIds: [], //所有展示类目数据
      cateLoading: true,
      baseUrl: this.$store.state.apiUrl,
      accept: ".jpg,.jpeg,.png,.JPG,.JPEG,.PNG",
      uploadAction:
        this.$store.state.apiUrl + "/api/services/app/Image/UploadImage", //上传的服务器api地址
      headers: {
        Authorization: localStorage.getItem("accessToken"),
      },
      goodsImagesList: [], //商品相册file-list
      goodsDescripImagesList: [], //商品详情图片file-list
      uploadIndex: 0, //上传规格图片的index
      btnLoading: false, //添加按钮loading
       dialogVisible: false,
            dialogImageUrl: ''
    };
  },
  components: {
    headerNotice,
  },
  created() {
    if (this.$route.query.applyID) {
      this.applyID = this.$route.query.applyID;
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
     handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
    //获取商品详情
    getData() {
      let self = this;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminApply/GetApply?ApplyID=" +
          this.applyID,
        success(res) {
          self.formData = res;

          self.cateLoading = false;
          let images = [];
          //解析相册图片
          if (self.formData.status == 1) {
            self.formData.flat = 1;
          }

          let list = res.receipt.split(",");
          list.forEach((ele, index) => {
            images.push(ele);

            self.goodsImagesList.push({
              name: ele,
              url: self.baseUrl + ele,
            });
          });
          self.loading = false;
        },
        fail(res) {
          self.cateLoading = false;
          self.loading = false;
        },
      });
    },
     getImgList(imgList) {
      var imgsurl = [];
      for (var i = 0; i < imgList.length; i++) {
        imgsurl.push(imgList[i].url || imgList[i].imageUrl );
      }
      this.formData.image = imgsurl.join(',');
    },
    handleExceed() {
      this.$message.error("抱歉，最多上传一张图片！如更换，请删除原先图片！");
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (file.type != "image/jpeg" && file.type != "image/png") {
        this.$message.error("上传的图片只支持JPG/PNG 的格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 1MB!");
      }
      return isLt2M;
    },
blurinput(){
   let self = this;
  $http.POST({
          url:
            this.$store.state.apiUrl +
            "/api/services/app/AdminApply/CheckApply",
          data: self.formData,
          success(res) {
            if (res.code != 200) {
              self
                .$confirm("该单号已经存在 ", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                .then(() => {
  
                })
                .catch(() => {});
            } else {

            }
            self.btnLoading = false;
          },
          fail(res) {
            self.btnLoading = false;
          },
        });
},
    //确认修改商品
    confirmEdit() {
      let self = this;
      this.btnLoading = true;
      if (
        !this.formData.storeName ||
        !this.formData.receiptNo ||
        this.formData.receiptNo == 1 ||
        !this.formData.ticketAmount
      ) {
        self.$message.error("请检查必填项是否填写！");
        self.btnLoading = false;
        return;
      }
      if (this.formData.receiptNo && this.formData.status == 2) {
        $http.POST({
          url:
            this.$store.state.apiUrl +
            "/api/services/app/AdminApply/CheckApply",
          data: self.formData,
          success(res) {
            debugger;
            if (res.code != 200) {
              self
                .$confirm("该单号已经存在 是否通过审核？, 是否继续?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                .then(() => {
                  self.postdata();
                })
                .catch(() => {});
            } else {
              self.postdata();
            }
            self.btnLoading = false;
          },
          fail(res) {
            self.btnLoading = false;
          },
        });
      } else {
        self.postdata();
      }
    },
    postdata() {
      let self = this;
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminApply/PostUpdateApply",
        data: this.formData,
        success(res) {
          self.$message({
            message: "审核成功",
            type: "success",
          });
          self.$router.back();
          self.btnLoading = false;
        },
        fail(res) {
          self.btnLoading = false;
        },
      });
    },
    //取消返回
    back() {
      this.$router.back();
    },
    Customization(that) {
      let self = this;
      if (that == false) {
        self.IsCustomized = false;
      } else {
        self.IsCustomized = true;
      }
    },
  },
};
</script>

<style lang='scss' scoped>
// 基本信息
.baseInfo {
  margin: 20px 50px;
  border: 1px solid #999;
  h1 {
    background: #f3f3f3;
    padding: 10px 20px;
    span {
      font-size: 12px;
      color: #999;
      i {
        font-style: normal;
      }
    }
  }
  .table {
    margin-top: 20px;
    .displayCate {
      display: flex;
      flex-direction: column;
      border: 1px solid #999;
      li {
        display: flex;
        flex-direction: column;
        border-bottom: 1px solid #999;
        box-sizing: border-box;
        padding: 0 20px;
        &:nth-last-child(1) {
          border: none;
        }
        .firstName {
          font-size: 18px;
          color: #000;
        }
        .groupBox {
          padding-left: 40px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          /deep/ .radio {
            margin: 0 20px 10px 0;
          }
        }
      }
    }
  }
  .goodsBox {
    padding: 20px;
  }
  .specification {
    margin-top: 20px;
    width: 100%;
    box-sizing: border-box;
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    table {
      width: 100%;
      table-layout: fixed;
      word-break: break-all;
      border: 1px solid #ccc;
      thead {
        width: 100%;
        th {
          height: 50px;
          font-size: 14px;
          color: #666;
          border: 1px solid #ccc;
        }
      }
      tbody tr {
        border: 1px solid #ccc;
        td {
          height: 50px;
          border: 1px solid #ccc;
          vertical-align: middle;
          text-align: center;
          padding: 10px 0;
          box-sizing: border-box;
          textarea {
            width: 80%;
            appearance: none;
            outline: none;
            border: none;
            min-height: 100px;
            background: #f9f9f9;
            resize: none;
          }
          input {
            text-align: center;
            width: 95%;
            height: 80%;
            outline: none;
            border: none;
            background: #f9f9f9;
          }
          img {
            display: inline-block;
            width: 100px;
            height: 100px;
            cursor: pointer;
          }
          &.spePic {
            padding: 10px;
          }
        }
      }
    }
    .addSpecification {
      margin: 20px 0;
    }
  }
  .saveBox {
    border-top: 1px solid #999;
    width: 100%;
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .linkIpt {
    padding: 15px 50px;
  }
  .direct {
    width: 20%;
  }
  .inlineBl {
    display: inline-block;
  }
}
</style>
<style>
</style>
